import { Injectable } from "@angular/core";
import{ Http, Headers } from "@angular/http";
import { map } from 'rxjs/operators';
import { GLOBAL } from './global';
@Injectable()
export class OptionService {
    public url;

    constructor(private _http: Http){
        this.url = GLOBAL.url;
        
    }

    getServices(){
        let headers = new Headers({
            'Content-type': 'application/json',

        });
        return this._http.get(this.url+'get/services', {headers: headers})
        .pipe(map(res=> res.json()));
    }

}




